import styled from "styled-components";
import { PrimaryButton } from "@gf-easy-8/grmnext-foundation";


export const ProductAccessContainer = styled("div")`
  margin-top: 20px;
  margin-bottom: 20px;
  min-height: 400px;
`;
ProductAccessContainer.displayName = "ProductAccessContainer";

export const ProductAccessRowContainer = styled("div")`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;
ProductAccessRowContainer.displayName = "ProductAccessRowContainer";

export const ProductAccessRowLeftContainer = styled("div")`
  display: flex;
  width: 30%;
`;
ProductAccessRowLeftContainer.displayName = "ProductAccessRowLeftContainer";

export const ProductAccessRowRightContainer = styled("div")`
  display: flex;
  flex-grow: 1;
  margin: 0 30px;

  & .MuiSlider-thumb.Mui-disabled {
    height: 15px;
    width: 15px;
    margin-top: -5px;
  }
`;
ProductAccessRowRightContainer.displayName = "ProductAccessRowRightContainer";

export const ProductAccessRowRightLabelsContainer = styled("div")`
  display: flex;
  flex: 1;
  div {
    text-align: center;
  }
  div:first-child {
    text-align: left;
  }
  div:last-child {
    text-align: right;
  }
`;
ProductAccessRowRightLabelsContainer.displayName =
  "ProductAccessRowRightLabelsContainer";

export const ProductAccessRowRightLabelContainer = styled("div")`
  flex: 1;
`;
ProductAccessRowRightLabelContainer.displayName =
  "ProductAccessRowRightLabelContainer";

export const ProductAccessCoreContainer = styled("div")`
  margin-top: 20px;
  margin-bottom: 20px;
`;
ProductAccessCoreContainer.displayName = "ProductAccessCoreContainer";

export const StyledPrimarySaveButton = styled(PrimaryButton)`
  position: absolute;
  bottom: 24px;
  right: 24px;
}
`;
ProductAccessCoreContainer.displayName = "ProductAccessCoreContainer";

export const ProductAccessSubAccessContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 100%;
  box-shadow: inset 2px -2px 4px ${(props) =>
    props.theme.colours.global.fadedBlack}, inset -2px -2px 2px ${(props) =>
  props.theme.colours.global.fadedBlack};
  background: ${(props) => props.theme.colours.global.fadedBlack}};
  border-top: none;
  padding: 10px 15px;
  margin: 10px -5px 15px -5px;
`;
ProductAccessSubAccessContainer.displayName = "ProductAccessSubAccessContainer";

export const IconInfoTooltipContainer = styled("div")`
  width: 16px;
  margin-left: 8px;
  padding-top: 2px;
  stroke: currentColor;
  fill: currentColor;
  color: ${(props) => props.theme.colours.global.lightFadedWhite}};

  & > div > div > span {
    right: -9px;
  }
`;
IconInfoTooltipContainer.displayName = "IconInfoTooltipContainer";